import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;

  & > figure {
    margin-inline: auto;
    max-height: 765px;
    max-width: 100%;
    overflow: hidden;

    & > img {
      width: 100%;
    }
  }
`

export const Content = styled.div`
  background-color: #084F43;
  margin-inline: auto;
  padding: 72px 62px;
  width: 100%;

  @media (max-width: 568px) {
    padding: 62px 24px;
  }
`

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-inline: auto;
  max-width: 1002px;
  width: 100%;

  @media (max-width: 568px) {
    align-items: initial;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > h1 {
    color: #FFF;
    font-size: 2rem;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -1px;
    text-align: center;
  }

  & > p {
    color: #FFF;
    font-size: 1.5rem;
    font-weight: 400;
    text-align: center;
  }

  @media (max-width: 568px) {
    & > p {
      font-size: 1rem;
    }
  }
`
